<input
  #dateInput
  [matDatepicker]="datepicker"
  [ngModel]="internalValue()"
  (ngModelChange)="onDateChange($event)"
  (close)="pickerClosed.emit()"
  [class.even]="rowNum() % 2 === 1 || false"
  [class.datetime]="column() | isColumnType: 'DateTime'"
  [readOnly]="
    column().isComputed ||
    (column() | isColumnType: 'CreatedTime') ||
    (column() | isColumnType: 'LastUpdatedTime')
  "
  (click)="datepicker.open()"
  blazeInputMask
  predefinedMask="datetimeInputMask"
  [maskOptions]="{ dateFormat: 'YYYY-MM-DD' }"
  (keydown.ArrowLeft)="moveCarriage(-1, dateInput)"
  (keydown.ArrowRight)="moveCarriage(1, dateInput)"
  data-cy="FieldInput:DateInput"
  class="input-datetime flex-[3]"
/>
<mat-datepicker
  #datepicker
  panelClass="bl-datepicker"
  [startView]="'month'"
  [touchUi]="false"
  [restoreFocus]="false"
  (opened)="afterDatePickerOpen()"
  (closed)="pickerClosed.emit()"
  [calendarHeaderComponent]="datepickerHeader"
/>
